import { Component, OnInit, OnDestroy, ViewChild, HostListener, NgZone, AfterViewInit, QueryList, ViewChildren, ElementRef, OnChanges, HostBinding } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../_services/authenticationService';
import { AppStateService } from '../../_services/state.service';
import { NavController, Platform, IonRouterOutlet, ModalController } from '@ionic/angular';
import { DialogService } from '../../_services';
import { RouteNavigationService } from '../../_services/routeNavigationService';
import { ContactUsComponent } from '../../_modals/contact-us/contact-us.component';
import { InvoiceService } from '../../invoices/invoice.service';
import { StringConstants } from '../../_constants/stringConstants';
import { CommonService } from '../../_services/common.service';
import { AppConfigService } from '../../_services/appConfigService';
import { AppDialogsService } from '../../_services/appDialogsService';
import { AppInfoService } from '../../_services/appInfoService';
import { AppThemeService } from '../../_services/appThemeService';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../layoutService';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { HelpMessageComponent } from '../../_modals/help-message/help-message.component';
import { OfflineService } from '../../_services/offlineService';


export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
})
export class HomeLayoutComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  
  @HostBinding('class.active') isMenuOpen: boolean = false;

 

  // private bannerResponseYes: string = this.translate.instant('MESSAGES.BANNER_REPSPONSE_YES');
  // private bannerResponseNo: string = this.translate.instant('MESSAGES.BANNER_REPSPONSE_NO');
  // private pressBackAgain: string = this.translate.instant('LABELS.PRESS_BACK_AGAIN');
  // private logoutOfApp: string = this.translate.instant('LABELS.LOGOUT_OF_APP');
  // private pleaseConfirm : string = this.translate.instant('MESSAGES.PLEASE_CONFIRM');
  // private cancel : string = this.translate.instant('LABELS.CANCEL');
  // private ok : string = this.translate.instant('LABELS.OK');

  currentAppData: any = {};

  currentLang = 'en';
  options: Options;
  theme = 'light';
  showSettings = false;
  isDocked = false;
  isBoxed = false;
  isOpened = true;
  mode = 'dock';
  _mode = this.mode;
  _autoCollapseWidth = 991;
  width = window.innerWidth;
  subscriptions = [];
  auto_pull_allowed = false;

  userName = '';
  pin = '';

  lastTimeBackPress = 0;
  timePeriodToExit = 1000;

  exitOnNextBackPress = false;

  versionInfo;
  deployDate;
  currentPlatformIsWeb;

  logo = 'payex.png';
  logo_sm = 'payex.png';


  currentRouteUrl = '/invoices';  // /home

  menuItems = [];
  menuItemHandlerFn = {
    logout: () => {
      this.logout();
    },
    contactUs: () => {
      this.contactUs();
    },
    refreshCashDiscount: () => {
      this.refreshCashDiscount();
    },
    showCFBanner: () => {
      this.showCFBaner();
    },
    openHelp: () => {
      this.openHelp();
    }
  };

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  @ViewChild('sideMenu') sideMenu: ElementRef;
  menu: any;
  isCondensed = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private appStateService: AppStateService,
    private nav: NavController,
    private dialogService: DialogService,
    private platform: Platform,
    private routeNavigationService: RouteNavigationService,
    private invoiceService: InvoiceService,
    private commonService: CommonService,
    private appConfig: AppConfigService,
    private appDialogsService: AppDialogsService,
    private appInfoService: AppInfoService,
    public appThemeService: AppThemeService,
    private translate: TranslateService,
    private layoutService: LayoutService,
    private stateService: AppStateService,
    private offlineService : OfflineService,
  ) {
  }

  ngOnInit(): void {
    const appStateSubscription = this.appStateService.currentAppState.subscribe(x => {
      this.currentAppData = x;
    });
    this.subscriptions.push(appStateSubscription);

    const userStateSubscription = this.authService.currentUser.subscribe(x => {
      if (this.userName && !x) {
        this.routeNavigationService.navigateRoot('/signin');
        return;
      }
      this.initUser();
    });

    const backButtonSubscription = this.platform.backButton.subscribe(() => {
      if (this.routeNavigationService.exitOnNextBackPress) {
        navigator['app'].exitApp();
      }
      if (this.routeNavigationService.childRoutes.indexOf(this.router.url) !== -1) {
        this.routeNavigationService.navigateToAppHome();
      }
      if (new Date().getTime() - this.lastTimeBackPress <= this.timePeriodToExit) {
        this.routeNavigationService.setExitToTrue();
        this.dialogService.showMessageDialog(this.translate.instant('LABELS.PRESS_BACK_AGAIN'));
      }
      this.lastTimeBackPress = new Date().getTime();
    });

    this.subscriptions.push(userStateSubscription);
    this.subscriptions.push(backButtonSubscription);

    this.versionInfo = this.appConfig.getVersionInfoStr();
    this.currentPlatformIsWeb = !this.commonService.getCurrentPlatform().is('cordova');

    this.dialogService.initDialogService();

    this.currentRouteUrl = document.location.href.split('#')[1];
    this.isCondensed = this.layoutService.getIsCondensed();
    this.getCurrentTheme();
    //Login state clearance
    this.stateService.clearLandingState();
    this.stateService.clearStaticState('landingState');
  }

  initUser() {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      this.userName = currentUser.userName;
      this.pin = currentUser.pin;
      this.auto_pull_allowed = currentUser.auto_pull_allowed;
      this.menuItems = this.appConfig.getAppMenuItems(currentUser);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(_ => this.runOnRouteChange());
  }

  ngOnDestroy() {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    });
  }

  runOnRouteChange(): void {
  }

  logout() {
    this.dialogService.showConfirmDialog({
      header: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
      message: this.translate.instant('MESSAGES.CONFIRM_LOGOUT_QUESTION'),
      ok: this.translate.instant('LABELS.YES,_LOG_ME_OUT'),
      cancel: this.translate.instant('LABELS.CANCEL')
    }).then((res) => {
      if (res) {
        this.authService.logout();
        this.offlineService.clearOfflineDocuments()
        this.routeNavigationService.navigateRoot('/signin');
      }
    });
  }

  async contactUs() {
    this.appDialogsService.openModal(ContactUsComponent, {});
  }

  openHelp() {
    this.appDialogsService.openModal(HelpMessageComponent, {}, {size: 'md'});
    //this.commonService.openInNewWindow(this.appInfoService.getAppHelpUrl(), false);
  }

  refreshCashDiscount() {
    const invoicesUrl = `/invoices/`;
    const currentRouteIsInvoice = this.routeNavigationService.currentRoute === invoicesUrl;
    if (!currentRouteIsInvoice) {
      this.routeNavigationService.navigateRoot(invoicesUrl);
    }
  }

  navRoot(menuItem) {
    
    if (menuItem && menuItem.fn) {
      return this.menuItemHandlerFn[menuItem.fn]();
    } else {
      this.routeNavigationService.navigateRoot(menuItem.route || '/invoices');// /home
      this.currentRouteUrl = menuItem.route;
      if(this.isMobileMode()){
        this.onToggleMobileMenu(event);
        console.log("inside nav")
        document.body.classList.remove('sidebar-enable');
      }
        
      
    }
  }
  



  showCFBaner() {
    this.appDialogsService.showCFBanner({
      cb: (data) => {
        const mode = data && data.data && data.data.resolve;
        if (mode) {
          this.dialogService.showInfoAlert(this.translate.instant('MESSAGES.BANNER_REPSPONSE_YES'));
        } else {
          this.dialogService.showInfoAlert(this.translate.instant('MESSAGES.BANNER_REPSPONSE_NO'));
        }
      }
    });
  }

  onActivate(event) {
  }

  setThemeMode() {
  }

  onToggleMobileMenu(event) {
    this.layoutService.toggleSidebar();
    this.isCondensed = this.layoutService.getIsCondensed();
    
  }

  ngOnChanges() {
    const isCondensed = this.layoutService.getIsCondensed();
    if (!isCondensed && this.sideMenu) {
      this.setMenu();
    } else if (this.menu) {
      this.menu.dispose();
    }
    this.isCondensed = isCondensed;
  }

  private setMenu() {
    setTimeout(() => {
      this.menu = new MetisMenu('#side-menu');
    }, 100);
    this._activateMenuDropdown();
  }

  _activateMenuDropdown() {
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (window.location.pathname === links[i]['pathname']) {
        menuItemEl = links[i];
        break;
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');

      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('active');

        const parent2El = parentEl.parentElement;
        if (parent2El) {
          parent2El.classList.add('in');
        }

        const parent3El = parent2El.parentElement;
        if (parent3El) {
          parent3El.classList.add('active');
          parent3El.firstChild.classList.add('active');
        }
      }
    }
  }

  switchTheme() {
    this.layoutService.switchTheme();
    setTimeout(() => {
      this.getCurrentTheme();
    }, 250);
  }

  getCurrentTheme() {
    this.theme = this.layoutService.getCurrentThemeMode();
    console.log(this.theme);
  }

  isMobileMode() {
    return window.innerWidth < 993;
  }
  @HostListener('document:click', ['$event']) click(e) {
    
    const sideBarEnabled = document.body.classList.contains('sidebar-enable');

    if(sideBarEnabled && this.isMenuOpen==false && this.isMobileMode()){
      
      this.isMenuOpen=true;
    }else if(sideBarEnabled && this.isMenuOpen==true && this.isMobileMode()){
      this.isMenuOpen=false;
      this.onToggleMobileMenu(event);
      

    }
    // console.log(e);
    // this.onToggleMobileMenu(event);
}

 
  //  console.log(this.isCondensed = this.layoutService.getIsCondensed());

   

  }
  

